var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMargin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 13,
    viewBox: "0 0 19 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 0.798615H13.58C13.02 0.798615 12.58 1.24244 12.58 1.80731C12.58 2.37218 13.02 2.81601 13.58 2.81601H15.56L10.7 7.73844L7.52 4.51062C7.12 4.10714 6.5 4.10714 6.1 4.51062L0.3 10.3611C-0.1 10.7645 -0.1 11.3899 0.3 11.7934C0.5 11.9951 0.76 12.096 1 12.096C1.24 12.096 1.52 11.9951 1.7 11.7934L6.78 6.66922L10 9.87688C10.4 10.2804 11.02 10.2804 11.42 9.87688L17 4.24835V6.24557C17 6.81044 17.44 7.25427 18 7.25427C18.56 7.25427 19 6.81044 19 6.24557V1.80731C19 1.24244 18.56 0.798615 18 0.798615Z",
    fill: "#B6B7E7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMargin);
export default __webpack_public_path__ + "static/media/Margin.9b559b30.svg";
export { ForwardRef as ReactComponent };